var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyticsSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 22H2.5C2.09 22 1.75 21.66 1.75 21.25C1.75 20.84 2.09 20.5 2.5 20.5H22.5C22.91 20.5 23.25 20.84 23.25 21.25C23.25 21.66 22.91 22 22.5 22Z",
    fill: "#6C84F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 4V22H14.75V4C14.75 2.9 14.3 2 12.95 2H12.05C10.7 2 10.25 2.9 10.25 4Z",
    fill: "#6C84F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10V22H7.5V10C7.5 8.9 7.1 8 5.9 8H5.1C3.9 8 3.5 8.9 3.5 10Z",
    fill: "#6C84F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15V22H21.5V15C21.5 13.9 21.1 13 19.9 13H19.1C17.9 13 17.5 13.9 17.5 15Z",
    fill: "#6C84F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsSvg);
export default __webpack_public_path__ + "static/media/AnalyticsSvg.923062aff5093447f15faa305c88e3c5.svg";
export { ForwardRef as ReactComponent };